/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_1_SolutionInputs */

const et_portfolio_project_1_solution = /** @type {(inputs: Portfolio_Project_1_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ehitasime lehe ümber ja optimeerisime SEO jaoks, parandasime konversioonile suunatud sisu ja rakendasime sihitud liiklusstrateegia.`)
};

const en_portfolio_project_1_solution = /** @type {(inputs: Portfolio_Project_1_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebuilt and SEO-optimized the site, improved conversion-focused content, and implemented a targeted traffic strategy.`)
};

/**
* | output |
* | --- |
* | "Rebuilt and SEO-optimized the site, improved conversion-focused content, and implemented a targeted traffic strategy." |
*
* @param {Portfolio_Project_1_SolutionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_1_solution = /** @type {((inputs?: Portfolio_Project_1_SolutionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_1_SolutionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_1_solution(inputs)
	return en_portfolio_project_1_solution(inputs)
});